import { render, staticRenderFns } from "./CreateFixedAsset.vue?vue&type=template&id=b0559288"
import script from "./CreateFixedAsset.vue?vue&type=script&lang=js"
export * from "./CreateFixedAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports